import { useCallback, useState } from "react";
import { salesService } from "../../api_client";
import { showErrorToast, showSuccessToast } from "../../../utils/toasts";

export function useConfirmSaleOrder() {
  const [isLoading, setIsLoading] = useState(false);

  const confirmSaleOrder = useCallback(async (id: number): Promise<boolean> => {
    setIsLoading(true);
    try {
      await salesService.adminApproveSaleDelivery(id);
      showSuccessToast("Sale order confirmed successfully!");
      return true;
    } catch (error) {
      console.error("Failed to confirm sale order:", error);
      showErrorToast("Failed to confirm sale order. Please try again.");
      return false;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { confirmSaleOrder, isLoading };
}
